import {
    Accordion,
    AccordionHeader,
    AccordionItem,
    AccordionPanel,
    makeStyles,
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import Status from "../../../enums/Status";
import MobileMainLink from "./MobileMainLink";
import { useMobileStyles } from "./MobileStyles";
import MobileArea from "./MobileArea";
import MobileLink from "./MobileLink";
import INavigationArea from "../../../models/navigation/INavigationArea";
import INavigationLink from "../../../models/navigation/INavigationLink";
import { NIL } from "uuid";

const useStyles = makeStyles({
    menu: {
        display: "flex",
		flexDirection: "column",
		gap: "0.5rem",
		alignItems: "flex-start",
		textAlign: "left",
		width: "100%",
    }
});

interface IMobileMenuProps {
    areas: INavigationArea[];
    status: Status;
    onNavigate: () => void;
}

export default function MobileMenu(props: IMobileMenuProps) {
    const { areas, status } = props;

    const { t } = useTranslation("navigation");
    const styles = useStyles();
    const mobileStyles = useMobileStyles();

    const isSupportSite = (process.env.REACT_APP_IS_SUPPORT_SITE || "").toLowerCase() === "true";

    const aboutLinks: INavigationLink[] = [
        { title: t("ourStory.ourStory"), pageId: NIL, path: "ourstory", isHidden: false },
        { title: t("ourStory.partners"), pageId: NIL, path: "partners", isHidden: false },
        { title: t("ourStory.jobs"), pageId: NIL, path: "jobs", isHidden: false },
        { title: t("ourStory.sustainability"), pageId: NIL, path: "sustainability", isHidden: false }
    ];
    
    const portfolioLinks: INavigationLink[] = [
        { title: t("ourStory.caseStudies"), pageId: NIL, path: "casestudies", isHidden: false },
        { title: t("ourStory.testimonials"), pageId: NIL, path: "testimonials", isHidden: false },
        { title: t("ourStory.awards"), pageId: NIL, path: "awards", isHidden: false }
    ];

    return (
        <div className={styles.menu}>
            <MobileMainLink path="/" text={t("home")} onNavigate={props.onNavigate} />
            <Accordion collapsible className={mobileStyles.accordion}>
                <AccordionItem value="1">
                    <AccordionHeader as="div" expandIconPosition="end" className={mobileStyles.accordionHeader}>
                        <span className={mobileStyles.button}>
                            {t("ourStory.ourStory")}
                        </span>
                    </AccordionHeader>
                    <AccordionPanel>
                        {
                            aboutLinks.map((link, index) => <MobileLink key={index} link={link} onNavigate={props.onNavigate} />)
                        }
                        {
                            portfolioLinks.map((link, index) => <MobileLink key={index} link={link} onNavigate={props.onNavigate} />)
                        }
                    </AccordionPanel>
                </AccordionItem>
                {
                    areas.map((area, index) => <MobileArea key={index} index={index + 2} area={area} onNavigate={props.onNavigate} />)
                }
            </Accordion>
            <MobileMainLink path="/blog" text={t("blog")} onNavigate={props.onNavigate} />

            {isSupportSite && (
                <>
                    <MobileMainLink path="/contact" text={t("contact")} onNavigate={props.onNavigate}/>
                    <MobileMainLink path="https://app.dolphin-support.co.uk/" text={t("login")} onNavigate={props.onNavigate} />
                </>
            )}
            
            {!isSupportSite && (
                <MobileMainLink path="/contact" text={t("contact")} onNavigate={props.onNavigate} />
            )}
        </div>
    );
};